import React from 'react';
import MainUploadPage from '../components/InvoiceUpload/MainUploadPage.jsx';

export default function UploadLanding() {
    return (
        <div>
            <MainUploadPage />
        </div>
    );
};
